import solutionsSlice from './solutionsSlice';

export { default as solutionsOp } from './operations';

export default solutionsSlice;
